import { FC, PropsWithChildren } from 'react';
import { useLocation } from 'react-router';

import { cn } from '@app/componentLibrary/utils';

import './AppContent.scss';

const Content: FC<PropsWithChildren> = ({ children }) => {
    const pathname = useLocation().pathname;
    const isOnboardingDetails = pathname === '/user/onboarding/details';
    const isOnboarding = pathname === '/user/onboarding';
    const isHome = pathname.includes('/user/sparks');

    return (
        <div
            className={cn(
                'app-content',
                isOnboardingDetails && 'bg-white max-w-full',
                isOnboarding && 'bg-cerulean-600 max-w-full',
                isHome && 'px-0',
            )}
        >
            {children}
        </div>
    );
};

export default Content;
